import * as AgGrid from "ag-grid-community";
import * as translations from "utils/translations";
import * as dom from "utils/dom";

export class BulkAction<T> {
  private $button: HTMLButtonElement;
  private $label: HTMLSpanElement;
  private actionFn: () => void;
  private i18nLabel: translations.Plural;
  private selectedNodes: AgGrid.IRowNode<T>[] = [];

  constructor($button: HTMLButtonElement) {
    this.$button = $button;
    this.$label = $button.querySelector("span");
    this.i18nLabel = JSON.parse($button.dataset.actionI18nLabel);
    this.renderLabel();
  }

  onClick(callback: (records: T[]) => void) {
    this.actionFn = dom.preventButtonDoubleClick(this.$button, async () => callback(this.selectedData()), 1000);
    this.$button.addEventListener("click", this.actionFn.bind(this));
  }

  onRowSelected(event: AgGrid.RowSelectedEvent) {
    this.selectedNodes = event.api.getSelectedNodes();
    this.renderLabel();
  }

  selectedData(): T[] {
    return Array.from(this.selectedNodes.map((node) => node.data));
  }

  private renderLabel() {
    const selectedCount = this.selectedNodes.length;

    this.$button.disabled = selectedCount === 0;

    if (!this.$label) {
      return;
    }

    this.$label.textContent = translations.pluralize(this.i18nLabel, selectedCount);
  }

  cleanup() {
    this.$button.removeEventListener("click", () => this.actionFn());
  }
}
